import { useState } from 'react';
import FaceIcon from "@mui/icons-material/Face";
import PhoneIcon from '@mui/icons-material/Phone';
import CreateIcon from '@mui/icons-material/Create';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import { Link } from 'react-router-dom';

import {HorizontalMenuContainer,StyledBottomNavigation, StyledBottomNavigationAction} from './styled';

import logo from '../../images/logo.png';

const HorizontalMenu = () => {
  const pathname = window.location.hash;
  const [value, setValue] = useState<string>(pathname);

  const handleChange = (event: any, newValue: string): void => {
    setValue(newValue);
  };

  return (
    <HorizontalMenuContainer>
      <img alt="logo" height="50" src={logo}/>
      <StyledBottomNavigation
      value={value}
        onChange={handleChange}
        showLabels
    >
      <StyledBottomNavigationAction value='#/' component={Link} to="/" label="O NAS" icon={<FaceIcon />} />
      <StyledBottomNavigationAction value='#/plantNursery' component={Link} to="/plantNursery" label="SZKÓŁKA ROŚLIN" icon={<HomeWorkIcon />} />
      <StyledBottomNavigationAction value='#/projects' component={Link} to="/projects" label="PROJEKTY" icon={<CreateIcon />} />
      <StyledBottomNavigationAction value='#/gardenCare' component={Link} to="/gardenCare" label="PIELĘGNACJA" icon={<LocalFloristIcon />} />
      <StyledBottomNavigationAction value='#/contact' component={Link} to="/contact" label="KONTAKT" icon={<PhoneIcon />} />
    </StyledBottomNavigation>
    </HorizontalMenuContainer>
  );
}

export default HorizontalMenu;
